<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <loading v-if="showLoading"></loading>
    <vote-success-modal v-if="showVoteSuccess" @hideModal="hideVoteSuccess"></vote-success-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Loading from '@components/Loading'
import VoteSuccessModal from './pages/rebuild/components/VoteSuccessModal'
import { verify, tools } from '@/utils'
//import store from './store'

export default {
  name: 'App',
  components: {
    Loading,
    VoteSuccessModal,
  },
  data() {
    return {
      curProvince: '',
      curCity: '',
    }
  },
  computed: {
    ...mapState(['showLoading', 'showVoteSuccess', 'authorization']),
  },
  methods: {
    ...mapMutations([
      'setShowVoteSuccess',
      'setCode',
      'setAuthorization',
      'setNickname',
      'setMobile',
      'setOpenid',
      'setChannel',
      'setCampaign',
      'setAccessId',
      'setActivityId',
    ]),
    hideVoteSuccess() {
      this.setShowVoteSuccess(false)
    },
    handleWxUserInfoSucc(res) {
      console.log(res)
      let data = res.data
      if (data.user_status == 1) {
        this.setAuthorization(data.authorization)
      }
    },
    getProfile: function () {
      this.$request
        .get(this.$apiConfig.myProfile)
        .then(res => {
          const resData = res.data
          if (resData.code == 0 && resData.data) {
            let d = resData.data
            this.setNickname(d.nickname)
            this.setMobile(d.mobile)
          } else {
            console.log(res.msg)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
  created() {
    if (!verify.isMobile()) {
      const reg = /regulation|protocol|pc/
      if (this.$route.path.match(reg) === null) {
        this.$router.replace('/pc')
        return
      }
    }
    const { campaign, channel, access_id, activity_id } = this.$route.query
    this.setCampaign(campaign)
    this.setChannel(channel)
    this.setAccessId(access_id)
    this.setActivityId(activity_id)

    if (this.authorization) {
      this.getProfile()
    }
  },
  mounted() {},
}
</script>

<style lang="scss">
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue